if (!customElements.get('header-cart')) {
  class HeaderCart extends HTMLElement {
    constructor() {
      super();

      this.cartCount = this.querySelector('.js-cart-count');

      this.bindEvents();
    }

    quantityUpdateUnsubscriber = undefined;
    cartUpdateUnsubscriber = undefined;

    connectedCallback() {
      requirejs(['pubsub'], () => {
        this.quantityUpdateUnsubscriber = subscribeEvent(
          PUB_SUB_EVENTS.fakeQuantityUpdate,
          ({ source, data }) => {
            this.updateFakeQuantity(data?.quantity);
          }
        );
  
        this.quantityUpdateUnsubscriber = subscribeEvent(
          PUB_SUB_EVENTS.quantityUpdate,
          ({ source, data: { data } }) => {
            this.updateQuantity(data);
          }
        );
  
        this.cartUpdateUnsubscriber = subscribeEvent(
          PUB_SUB_EVENTS.cartUpdate,
          ({ source, data }) => {
            const cartJson = this.getCartJsonFromDrawer(data?.sections?.['cart-drawer']);
            this.updateQuantity(cartJson);
          }
        );
      });
    }

    disconnectedCallback() {
      if (this.quantityUpdateUnsubscriber) this.cartUpdateUnsubscriber();
      if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
    }

    bindEvents() {
      this.openDrawer();
    }

    updateQuantity(cartData) {
      if (this.cartCount && cartData) {
        const variantKeys = JSON.parse(localStorage.getItem('removedItem'));
        let cartCount = cartData.item_count;

        /* If has fake removed item (ignore theme) */
        if (variantKeys?.length > 0) {
          cartCount = 0;
          cartData.items.forEach((cartItem) => {
            if (!variantKeys.includes(cartItem.id)) {
              cartCount += cartItem.quantity;
            }
          });
        }

        if (cartCount == 1) {
          this.classList.remove('is-multiple');
          this.classList.add('is-single');
        } else {
          this.classList.add('is-multiple');
          this.classList.remove('is-single');
        }

        this.cartCount.textContent = cartCount;
        this.cartCount.setAttribute('data-count', cartCount);
      }
    }

    updateFakeQuantity(qty) {
      const totalQty = +this.cartCount.dataset.count + qty;

      this.cartCount.setAttribute('data-count', totalQty);
    }

    getCartJsonFromDrawer(cartDrawerHTML) {
      const cartDrawer = new DOMParser().parseFromString(cartDrawerHTML, 'text/html');
      const cartScriptData = cartDrawer.querySelector('.js-cart-json');

      return JSON.parse(cartScriptData.textContent);
    }

    openDrawer() {
      const cartDrawer = document.querySelector('cart-drawer');
      const cartDrawerHeader = document.querySelector('.js-cart-drawer-header');

      this.addEventListener('click', (event) => {
        event.preventDefault();
        cartDrawer.open();

        window.debounce(() => {
          cartDrawerHeader.classList.remove('success');
        }, 4000)();
      });
    }
  }

  customElements.define('header-cart', HeaderCart);
}
